import React from 'react';
import { FileText, CheckSquare } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@shared/components/ui/button';
import { cn } from '@shared/lib/utils';

interface FloatingNavProps {
  onToggleNotes?: () => void;
  showNotes?: boolean;
}

// Bottom-center pill nav, mirroring the extension's FloatingNav (web has no Tabs).
const FloatingNav = ({ onToggleNotes, showNotes }: FloatingNavProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isNotesPage = location.pathname === '/' || location.pathname.startsWith('/notes');
  const isTasksPage = location.pathname === '/tasks';

  const handleNotesClick = () => {
    if (isNotesPage && onToggleNotes) onToggleNotes();
    else navigate('/');
  };

  return (
    <div className={cn(
      "fixed bottom-4 left-1/2 -translate-x-1/2 z-50",
      "flex items-center gap-4 px-4 py-2 rounded-full",
      "bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60",
      "border shadow-lg"
    )}>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleNotesClick}
        className={cn(
          "rounded-full flex items-center gap-2 transition-colors",
          (isNotesPage && showNotes) && "text-hintword-orange hover:text-hintword-orange/90",
          isNotesPage && "font-medium"
        )}
        title={isNotesPage ? "Toggle Notes" : "Go to Notes"}
      >
        <FileText className="h-4 w-4" />
        <span className="text-sm">Notes</span>
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => navigate('/tasks')}
        className={cn(
          "rounded-full flex items-center gap-2 transition-colors",
          isTasksPage && "font-medium text-primary"
        )}
        title="Go to Tasks"
      >
        <CheckSquare className="h-4 w-4" />
        <span className="text-sm">Tasks</span>
      </Button>
    </div>
  );
};

export default FloatingNav;
